import Paper from '@mui/material/Paper';
import React from 'react';
import {Pagination} from '../../../components/Pagination';
import {SupportTicketAttachmentDrawer} from './components/SupportTicketAttachmentDrawer';
import {SupportTicketDrawer} from './components/SupportTicketDrawer';
import {SupportTicketFilterBar} from './components/SupportTicketFilterBar';
import {SupportTicketRelatedTasksDrawer} from './components/SupportTicketRelatedTasksDrawer';
import {SupportTicketTable} from './components/SupportTicketTable';
import {useSupportPageState} from './state/support-page-state';

export const SupportPage = () => {
  const state = useSupportPageState()

  return <Paper sx={{height: '100%', width: '100%', padding: 2, position: 'relative'}}>
    <SupportTicketFilterBar
      translate={state.translate}
      translateLocal={state.translateLocal}
      searchableState={state.searchableState}
      searchText={state.searchableState.fullTextSearch}
      onSearchText={state.searchableState.onFullTextSearch}
      extractAvailableValues={state.extractAvailableValues}
    />
    <SupportTicketTable
      tickets={state.tickets}
      onTicketPressed={(ticket) => {
        state.setSelectedTicket(ticket)
        state.setDrawerOpen(true)
      }}
      onTicketRelatedTasksPressed={(ticket) => {
        state.setSelectedTicket(ticket)
        state.setRelatedTasksTicketOpen(true)
      }}
      onTicketAttachmentPressed={(ticket) => {
        state.setSelectedTicket(ticket)
        state.setAttachmentDrawerOpen(true)
      }}
      ordering={state.searchableState.searchable.ordering}
      onOrdering={state.searchableState.onOrdering}
      translateLocal={state.translateLocal}
      translate={state.translate}
    />
    <Pagination
      count={state.total}
      page={state.searchableState.searchable.page - 1}
      rowsPerPage={state.searchableState.searchable.pageSize}
      onPageChange={(page) => state.searchableState.onPage(page + 1)}
      onRowsPerPageChange={state.searchableState.onPageSize}
    />
    {
      state.selectedTicket === null
        ? <></>
        : <SupportTicketDrawer
          ticket={state.selectedTicket}
          isDrawerOpen={state.isDrawerOpen}
          refreshTickets={state.refreshTickets}
          translate={state.translate}
          translateLocal={state.translateLocal}
          onDrawerClosed={() => {
            state.setDrawerOpen(false);
            state.setSelectedTicket(null)
          }}
        />
    }
    {
      state.selectedTicket === null
        ? <></>
        : <SupportTicketRelatedTasksDrawer
          ticket={state.selectedTicket}
          isDrawerOpen={state.isRelatedTasksTicketOpen}
          translate={state.translate}
          onDrawerClosed={() => {
            state.setRelatedTasksTicketOpen(false);
            state.setSelectedTicket(null)
          }}
        />
    }
    {
      state.selectedTicket === null || !state.isAttachmentDrawerOpen
        ? <></>
        : <SupportTicketAttachmentDrawer
          isDrawerOpen={state.isAttachmentDrawerOpen}
          onDrawerClosed={() => {
            state.setAttachmentDrawerOpen(false);
            state.setSelectedTicket(null)
          }}
          translate={state.translate}
          ticket={state.selectedTicket}
        />
    }
  </Paper>
}